import { useCallback, useState, useEffect } from 'react';
import WebSocketManager from './WebSocketManager';
/**
 * Shared WebSocket connection hook to avoid multiple connections
 */
export const useSharedWebSocket = () => {
    const [isConnected, setIsConnected] = useState(false);
    const manager = WebSocketManager.getInstance();
    const subscribe = useCallback((subscriber) => {
        manager.subscribe(subscriber);
    }, [manager]);
    const unsubscribe = useCallback((subscriberId) => {
        manager.unsubscribe(subscriberId);
    }, [manager]);
    const sendMessage = useCallback((message) => {
        manager.sendMessage(message);
    }, [manager]);
    useEffect(() => {
        const updateConnectionState = () => {
            setIsConnected(manager.getConnectionState());
        };
        updateConnectionState();
        const interval = setInterval(updateConnectionState, 1000);
        return () => {
            clearInterval(interval);
        };
    }, [manager]);
    return {
        subscribe,
        unsubscribe,
        sendMessage,
        isConnected,
    };
};
export default useSharedWebSocket;
